module.exports = __webpack_public_path__ + "e0106718/img/share-icon.0f8a11b4.svg";